import React from 'react';
import PropTypes from 'prop-types';
import ViPropTypes from '../propTypes';
import classnames from 'classnames';
import {isEqual} from 'lodash';
import {getOerTime, getVideoTime, getBrakeEvents, getClutchEvents, getCruiseEvents} from '../util/media';
import {getOerIconName} from '../util/oer';

const getOerMarker = media => {
  const oerTime = getOerTime(media);

  if (!oerTime) {
    return false;
  }

  const video = getVideoTime(media);

  const oerSecond = ((oerTime.start - video.start) / 1000);
  let position = (oerSecond * 100) / video.duration;

  if (position >= 100) {
    position = 98;
  }

  return {
    position,
    icon: getOerIconName(oerTime.trigger)
  };
};

const getBrakeTimeline = media => {
  return parseTimeline(getBrakeEvents(media), media);
};

const getClutchTimeline = media => {
  return parseTimeline(getClutchEvents(media), media);
};

const getCruiseTimeline = media => {
  return parseTimeline(getCruiseEvents(media), media);
};

const parseTimeline = (timeline, media) => {
  const video = getVideoTime(media);

  return timeline.map(frame => {
    let endSecond = frame.endSecond + 1;
    
    if (endSecond > video.duration) {
      endSecond = video.duration;
    }
    
    const startPosition = (frame.startSecond * 100) / video.duration;
    let endPosition = ((endSecond * 100) / video.duration) + (video.duration * 0.005);

    if (endPosition > 100) {
      endPosition = 100;
    }

    return {
      startPosition,
      length: (endPosition - startPosition)
    };
  });
};

export default class Timeline extends React.Component {
  
  static propTypes = {
    mediaLoaded: PropTypes.bool,
    media: ViPropTypes.Media
  }

  static defaultProps = {
    mediaLoaded: true
  }

  state = {
    media: null,
    oerMarker: null,
    brakeData: [],
    clutchData: [],
    cruiseData: []
  }

  renderOerMarker() {
    const {oerMarker} = this.state;

    if (!oerMarker) {
      return null;
    }

    return (
      <div
        className="timeline__oerevent"
        style={{
          left: `${oerMarker.position}%`
        }}
      >
        <div className={`oericon ${oerMarker.icon}`} />
        <div className="marker" />
      </div>
    );
  }

  renderBrakeTimeline() {
    return this.renderTimeline(this.state.brakeData, 'brake');
  }

  renderClutchTimeline() {
    return this.renderTimeline(this.state.clutchData, 'clutch');
  }

  renderCruiseTimeline() {
    return this.renderTimeline(this.state.cruiseData, 'cruise');
  }

  renderTimeline(timelineData, type) {
    return (
      <div className="timeline__container">
        {timelineData && timelineData.map(brakeItem => (
          <div
            key={`${type}_${brakeItem.startPosition}`}
            className={`timeline__progress ${type}`}
            style={{
              left: `${brakeItem.startPosition}%`,
              width: `${brakeItem.length}%`
            }}
          />
        ))}
        <div className="timeline__bg" />
      </div>
    );
  }
  

  render() {
    return (
      <div
        className={classnames({
          timeline: true,
          hideme: !this.props.mediaLoaded
        })}
      >
        {this.renderOerMarker()}
        {this.renderBrakeTimeline()}
        {this.renderClutchTimeline()}
        {this.renderCruiseTimeline()}
      </div>
    );
  }

  static getDerivedStateFromProps(props, state) {
    const currentMedia = state.media;
    const newMedia = props.media;

    if (isEqual(currentMedia, newMedia)) {
      return null;
    }

    const oerMarker = getOerMarker(newMedia);
    const brakeData = getBrakeTimeline(newMedia);
    const clutchData = getClutchTimeline(newMedia);
    const cruiseData = getCruiseTimeline(newMedia);

    return {
      media: newMedia,
      oerMarker,
      brakeData,
      clutchData,
      cruiseData
    };
  }

}
